import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { FooterColumnCms } from '~/cms/interfaces/footer.cms.interface';
import { CmsService } from '~/cms/services/cms/cms.service';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { SocialButtonVariantEnum } from '~/component/social-button/enums/variant.enum';
import { SocialButtonConfigInterface } from '~/component/social-buttons/interfaces/social-button.config.interface';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { configuredLang } from '~/i18n/i18n.module';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { IconTypeEnum } from '../icon/enums/icon-type.enum';
@Component({
  selector: 'app-cms-footer',
  templateUrl: './cms-footer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CmsFooterComponent implements OnInit, OnDestroy {
  @Input() public columns: FooterColumnCms[] = [];
  @Input() public description: string;
  @Input() public logo: LogoTypeEnum;
  @Input() public title: FooterColumnCms[] = [];

  private readonly configuredLang = configuredLang;
  private readonly subscriptions = new Subscription();

  public readonly logoTypeEnum = LogoTypeEnum;
  public readonly socialButtonVariant = SocialButtonVariantEnum.Dark;

  public buttonsConfig: SocialButtonConfigInterface[] = [];
  public isMobileDevice: boolean;
  public language = new FormControl();
  public languages: { label: string; value: string }[] = [];

  constructor(
    private readonly matchMediaService: MatchMediaService,
    private readonly cmsService: CmsService,
    private readonly translateService: TranslateService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.language.setValue(this.translateService.currentLang);

    this.configuredLang.forEach((language) => {
      this.languages.push({
        label: this.translateService.instant(`cms.footer.language.${language}`),
        value: language,
      });
    });

    this.subscriptions.add(
      this.cmsService.getConfiguration().subscribe((configuration) => {
        if (!configuration?.social_networks) {
          return;
        }

        Object.keys(configuration?.social_networks)
          .filter((socialNetwork) => socialNetwork !== 'id')
          .forEach((socialNetwork) => {
            this.buttonsConfig.push({
              ariaLabel: this.translateService.instant(
                `a11y.cms.footer.social_newtwork.${socialNetwork.toLowerCase()}.link`
              ),
              iconType: IconTypeEnum[socialNetwork],
              isShareButton: false,
              name: '',
              nameKey: '',
              url: configuration?.social_networks[socialNetwork],
            });
          });
      })
    );

    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get collapsesIcon(): VtmnPlayIconTypeEnum {
    return this.isMobileDevice ? VtmnPlayIconTypeEnum.Add : null;
  }

  public get isCollapsesDisabled(): boolean {
    return !this.isMobileDevice;
  }

  public get isCollapsesOpen(): boolean {
    return !this.isMobileDevice;
  }

  public onLanguageChange(): void {
    window.location.href = `/${this.language.value}`;
  }
}
